import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';

export * from './MensajeAutomatico.types';
import { IMensajeAutomatico } from './MensajeAutomatico.lib';

export class MensajeAutomatico extends IMensajeAutomatico
{


    public static async create( id: string ): Promise<MensajeAutomatico>
    {
        let o = new MensajeAutomatico();
        o.Tipo = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/mensajeria/mensajesautomaticos';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Tipo}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<MensajeAutomatico>; Error?: boolean; }>
    {

        let a: Array<MensajeAutomatico> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/mensajeria/mensajesautomaticos` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new MensajeAutomatico( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Tipo}`;
                if ( await req.put() )
                {
                    //this.Json = req.data;
                    //this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${this.Route}/${this.Tipo}`;
                if ( await req.post() )
                {
                    //this.Json = req.data;
                    //this.set();
                    return true;
                }
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

}